import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable()
export class LoaderService {
  constructor(private loaderService: NgxUiLoaderService) { }

  
  openLoading(taskId: string = 'default') {
    this.loaderService.start(taskId);
  }

  closeLoading(taskId: string = 'default') {
    this.loaderService.stop(taskId);
  }
}
